var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueSelect',_vm._b({staticClass:"select-feature-field",model:{value:(_vm.valueAccessor),callback:function ($$v) {_vm.valueAccessor=$$v},expression:"valueAccessor"}},'VueSelect',_vm.selectFieldCommonVueSecectProps,false))}
var staticRenderFns = []

export { render, staticRenderFns }